import React , {useEffect, useRef, useState, useCallback} from 'react';
import Resolution from 'engine/Resolution.js';
import {connect} from 'react-redux';

const RESOLUTION_4 = new Resolution(4, false);
const RESOLUTION_8 = new Resolution(8, false);
const RESOLUTION_16 = new Resolution(16, false);
const RESOLUTION_32 = new Resolution(32, false);

export const RollButtons = ({resolution, sequencerEngine, isRolling}) => {
    return (
        <div className="roll-buttons">
          <RollButton
            isSequenceRolling={isRolling && resolution.resolution === 4}
            sequencerEngine={sequencerEngine}
            resolution={RESOLUTION_4}/>
          <RollButton
            isSequenceRolling={isRolling && resolution.resolution === 8}
            sequencerEngine={sequencerEngine}
            resolution={RESOLUTION_8}/>
          <RollButton
            isSequenceRolling={isRolling && resolution.resolution === 16}
            sequencerEngine={sequencerEngine}
            resolution={RESOLUTION_16}/>
          <RollButton
            isSequenceRolling={isRolling && resolution.resolution === 32}
            sequencerEngine={sequencerEngine}
            resolution={RESOLUTION_32}/>
        </div>
    );
}

const RollButton = ({resolution, sequencerEngine, isSequenceRolling}) => {
    let ref = useRef(undefined);
    const [rolling, setRolling] = useState(false);

    useEffect(() => {
        setRolling(isSequenceRolling);
    }, [isSequenceRolling, setRolling]);

    const onMouseDown = useCallback(() => {
        let map = {
            ...sequencerEngine.idToSequencerEngine,
            "-1": sequencerEngine.samplerTrack
        };
        let engine = map[Object.keys(map)[0]];
        if (engine === undefined) {
            return;
        }
        engine.resolution = resolution;
        engine.trackRolling = true;
        for (let key in map) {
            map[key].sequenceRolling = true;
        }
        setRolling(true);
    }, [setRolling]);

    const onMouseUp = useCallback(() => {
        let map = {
            ...
                sequencerEngine.idToSequencerEngine,
            "-1": sequencerEngine.samplerTrack
        };
        let engine = map[Object.keys(map)[0]];
        if (engine === undefined) {
            return;
        }
        engine.resolution = resolution;
        for (let key in map) {
            map[key].sequenceRolling = false;
        }
        engine.trackRolling = false;
        setRolling(false);
    }, [setRolling]);

    let className = "explore-roll-button";
    if (rolling) {
        className += " flash-it rolling";
    }

    return (
        <div
          ref={ref}
          onMouseDown={onMouseDown}
          onMouseUp={onMouseUp}
          onTouchStart={onMouseDown}
          onTouchEnd={onMouseUp}
          onTouchLeave={onMouseUp}
          className={className}>
          1/{resolution.resolution}
        </div>
    );
};

const mapStateToProps = (state, props) => {
    return {
        resolution: state.sequencer.resolution,
        isRolling: props.sequencerEngine.sequenceRolling()
    };
};

export default connect(mapStateToProps, null)(RollButtons);

